import React from 'react'
import { type IMenuItem, type IMenuProps } from '@components/Ackodrive/header/globalHeader'
import { SubMenuOptionWrapper } from './styles'
import { SubMenuOption } from './SubMenuOption'

const MenuHeader = ({ menuItems, menuItemsGap, menuFontSize, menuFontWeight, menuLineHeight }: IMenuProps) => (
  <SubMenuOptionWrapper menuItemsGap={menuItemsGap}>
    {menuItems?.map((menuItem: IMenuItem) => (
      <SubMenuOption
        key={menuItem?.title}
        menuItem={menuItem}
        menuFontSize={menuFontSize}
        menuFontWeight={menuFontWeight}
        menuLineHeight={menuLineHeight}
      />
    ))}
  </SubMenuOptionWrapper>
)

export default MenuHeader
